import classNames from 'classnames';

import styles from './_index.module.scss';

export interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  buttonRef?: React.RefObject<HTMLButtonElement>;
  'data-testid'?: string;
  icon?: React.ReactNode;
  isDisabled?: boolean;
  isLoading?: boolean;
  text?: React.ReactNode | string;
  variant?: 'ai' | 'error' | 'primary' | 'secondary' | 'tertiary';
}

const Button = ({
  buttonRef,
  className,
  'data-testid': dataTestId = 'button',
  icon,
  isDisabled,
  isLoading,
  text = 'Button',
  variant = 'primary',
  ...props
}: ButtonProps) => {
  return (
    <button
      className={classNames(styles[`button-${variant}`], className, {
        [styles['has-text']]: text,
      })}
      data-testid={dataTestId}
      disabled={isDisabled || isLoading}
      ref={buttonRef}
      {...props}
    >
      {isLoading ? (
        'Loading...'
      ) : (
        <>
          {icon && icon}
          {text}
        </>
      )}
    </button>
  );
};

export default Button;
